<template>
    <div class="servicesList">
        <div class="tabs">
            <ul class="lists" id='list' ref="tab">
                <li v-for="(item,i) in navLists" :key="i" v-bind:class='{ lists_active: index == i} '
                    @click="serviceChange(i)">
                    <router-link tag="div" :to="item.to">
                        <span class="tab-link">{{$t(item.title)}}</span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "servicesList",
        data() {
            return {
                navLists: [
                    {
                        to: '/traffic',
                        title: 'service.traffic'
                    }/*,
                    {
                        to: '/parkRoute',
                        title: '游园路线'
                    }*/, {
                        to: '/parkMap',
                        title: 'service.map_title'
                    }, {
                        to: '/workTime',
                        title: 'service.work_time'
                    }, {
                        to: '/problems',
                        title: 'service.problems_title'
                    }, {
                        to: '/visitorsNotice',
                        title: 'service.notice_title'
                    },
                    {
                        to: '/complaints',
                        title: 'service.complaints_title'
                    }, /*{
                        to: '/pictures',
                        title: '美图欣赏'
                    },*/
                    {
                        to: '/Clvideo',
                        title: 'service.video_title'
                    }, {
                        to: '/sale',
                        title: 'service.discount_title',
                    },
                    {
                        to: '/tourServer',
                        title: 'service.tour_server',
                    },{
                        to: '/serviceCheck',
                        title: 'service.security_check',
                    },
                ],
                index: '',
               /* mX: 0,
                tabWidth: 124,
                moveList: ''*/

            }
        },
        created() {
            this.index = this.$store.state.service.current_index;
        },
        methods: {
            serviceChange(i) {
                this.index = i;
                this.$store.commit("set_current_index", i);
            },
            _initScroll(){
                let tabs = this.$refs.tab;
                // console.dir();
                let childWidth= tabs.childNodes[0].clientWidth;
                let cWidth = document.documentElement.clientWidth ;
                tabs.scrollLeft += (this.current_index  * childWidth ) - ((cWidth - childWidth)/2);
            }
        },
        mounted() {
            this.$nextTick(() => {
                this._initScroll();
            })
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            },
            current_index: function () {
                return this.$store.state.service.current_index;
            },
        },


    }
</script>

<style scoped lang="less">
    @import "../../assets/less/nav";

    .servicesList {
        position: relative;
        width: 100%;
        .tabs {
            width: 100%;
            box-sizing: border-box;
            white-space: nowrap;

        }
    }

    .lists_active {
        color: @brick_red;
        &:after {
            background: @brick_red;
        }
    }

</style>
